<template>
  <section class="hbox stretch">
    <div class="content-header">      
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item><a href="/">运营</a></el-breadcrumb-item>
        <el-breadcrumb-item>功能模块</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content-main">
      <el-form :inline="true">            
        <!-- <el-form-item>
          <el-button type="primary" class="el-icon-circle-plus-outline" v-on:click="AddBusiness" >新增</el-button>
        </el-form-item> -->
        <el-form-item >
          <el-input  placeholder="名称" v-model="name"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="Search" >查询</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="rows" style="width: 100%">
        <el-table-column  fixed  prop="Name"  label="系统名称" width="120"> </el-table-column>
        <el-table-column  prop="Title"  label="显示名称" > </el-table-column>
        <el-table-column  prop="Icon" label="图标" width="80" align="center">
            <template slot-scope="scope">
              <el-popover
                v-if="scope.row.Icon"
                placement="right"
                trigger="hover"
              >
                <div>
                  <img
                    :src="scope.row.Icon"
                    max-width="400"
                    max-height="400"
                  >
                </div>  
                <img
                  slot="reference"
                  :src="scope.row.Icon"
                  width="20"
                  height="20"
                >
              </el-popover> 
              <p v-else>
                --
              </p>
            </template>         
          </el-table-column> 
        <el-table-column  prop="Mobile"  label="链接" > </el-table-column>
        <el-table-column  prop="Visabled"  label="是否显示"> 
          <template slot-scope="scope">
            <span v-if="scope.row.Visabled == true">显示</span>
            <span v-if="scope.row.Visabled == false">不显示</span>
          </template>
        </el-table-column>
        <el-table-column  prop="Sort"  label="排序"> </el-table-column>
        <el-table-column  fixed="right" label="操作" width="120">
        <template slot-scope="scope">
          <el-button @click.native.prevent="Edit(scope.row)" type="text" size="small">
            编辑
          </el-button>
        </template>
      </el-table-column>
      </el-table>
      <el-pagination
        :hide-on-single-page="true"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageIndex"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount">
      </el-pagination>
    </div> 
    <el-dialog title="模块设置" width="450px" :visible.sync="dialogFormVisible">
      <el-form ref="form" :model="pack" label-width="80px">
        <el-form-item label="系统名称">
          <el-col :span="20">
            <el-input v-model="pack.Name" :readonly="true"></el-input>
          </el-col>
        </el-form-item>        
        <el-form-item label="显示名称">
          <el-col :span="20">
            <el-input v-model="pack.Title"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="是否显示">
          <el-col :span="20">
            <el-switch
              v-model="pack.Visabled">
            </el-switch>
          </el-col>
        </el-form-item>
        <el-form-item label="排序">
          <el-col :span="20">
            <el-input v-model="pack.Sort"></el-input>
          </el-col>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="SavePack" >确 定</el-button>
      </div>
    </el-dialog> 
  </section>
  
</template>
<script  type='text/ecmascript-6'>
  export default {
    props:{
    },
    data (){
      return {
        name:'',
        pageIndex:1,
        pagesize:10,
        totalCount:10,
        totalPage:1,
        sort:'sort asc',
        rows:[],
        pack: {},
        dialogFormVisible: false
      }
    },
    computed:{
    },
    mounted(){
      this.GetDate();
    },
    methods:{     
      Search:function(){
        this.pageIndex = 1;
        this.GetDate();
      },
      GetDate:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/System/FeaturePack',
          params:{
            name : that.name,
            pageIndex : that.pageIndex,
            pagesize : that.pagesize,
            sort : that.sort
          }
        }).then(function (resp) {
          that.totalCount = resp.data.totalCount
          that.rows = resp.data.data
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      Edit(row){
        this.pack = row
        this.dialogFormVisible = true
      },
      SavePack() {
        var that = this
        this.axios({
          method:'post',
          url:that.global.serverSrc + '/api/System/SaveFeaturePack',         
          data:that.pack
        }).then(function (resp) {
          if(resp.data.errorCode==0){
            that.$message.success(resp.data.message);
            that.dialogFormVisible = false
            that.GetDate()
          }else {
            that.$message.warning(resp.data.message);
          }  
        }).catch(resp => {         
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
      }
    },
    components:{    
       
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-header
  padding 24px
  border 1px solid #C0C4CC
.content-main
  padding 24px  
</style>